
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about6Vgf2e_45ZWwa_45DDxcsm2LFgKBFkBxwt_su_XdCkSeybIMeta } from "/opt/buildhome/repo/pages/about.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as bylawsCpZw7RJ3L9DzgPEVsArxsDKN1lhM_sL6y6LrvmIqEtYMeta } from "/opt/buildhome/repo/pages/bylaws.vue?macro=true";
import { default as contactxgbCBTXU_45d0XJYTpbmfD1UGZKjSEtzA80xt962KkT7QMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as matchesT4gkKQYcy4_5kvEtux5Z6ACA8i4okrd3c819nq_oMP0Meta } from "/opt/buildhome/repo/pages/matches.vue?macro=true";
import { default as standings_gePCQI2xJG8dhq_zEMV6acOQJKL_iypUatea5nMhs4Meta } from "/opt/buildhome/repo/pages/standings.vue?macro=true";
import { default as league_45format7MfEaSA3y_LqWsIFIWJ0woGKsS3bgHibrxIIcce3FxQMeta } from "/opt/buildhome/repo/pages/league-format.vue?macro=true";
import { default as _91matchId_93EETa3JD8LArIU2cmeXPGUrQe7hPGE4I0mclOU4WG27UMeta } from "/opt/buildhome/repo/pages/match/[matchId].vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/opt/buildhome/repo/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "bylaws",
    path: "/bylaws",
    component: () => import("/opt/buildhome/repo/pages/bylaws.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "matches",
    path: "/matches",
    component: () => import("/opt/buildhome/repo/pages/matches.vue")
  },
  {
    name: "standings",
    path: "/standings",
    component: () => import("/opt/buildhome/repo/pages/standings.vue")
  },
  {
    name: "league-format",
    path: "/league-format",
    component: () => import("/opt/buildhome/repo/pages/league-format.vue")
  },
  {
    name: "match-matchId",
    path: "/match/:matchId()",
    component: () => import("/opt/buildhome/repo/pages/match/[matchId].vue")
  }
]